<template>
    <div
        ref="homeBanner"
        class="col-12 w-100 px-0 mx-0 d-flex main-image-wrapper home-banner"
    >
        <div
            v-if="isLoading"
            class="home-banner__loading"
        >
            <van-loading
                type="spinner"
                color="#2684ff"
                class="mx-auto"
            />
        </div>
        <b-carousel
            v-else
            id="carousel-1"
            :interval="3000"
            controls
            fade
            class="home-banner__carousel w-100"
        >
            <b-carousel-slide
                v-for="banner in banners"
                :key="banner.id"
                :img-src="banner.image"
            />
        </b-carousel>
    </div>
</template>

<script>
import { Loading } from 'vant';

const LOCAL_BANNERS = [
    { id: 'local-1', image: '/assets/banner-1.webp' },
    { id: 'local-2', image: '/assets/banner-2.webp' },
    { id: 'local-3', image: '/assets/banner-3.webp' },
    { id: 'local-4', image: '/assets/banner-4.webp' },
];

export default {
    name: 'HomeBanner',
    components: { [Loading.name]: Loading },
    data() {
        return {
            isLoading: true,
            banners: LOCAL_BANNERS,
        };
    },
    async mounted() {
        await this.fetchBanners();

        const isDesktopFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (isDesktopFinePointer) {
            this.$nextTick(() => {
                this.setupDesktopBannerWheel();
            });
        }
    },
    beforeDestroy() {
        this.teardownDesktopBannerWheel();
    },
    methods: {
        async fetchBanners() {
            try {
                this.isLoading = true;
                const res = await axios.get('/banners');
                const apiBanners = (res.data?.data || []).filter((banner) => banner.image);

                this.banners = apiBanners.length > 0 ? apiBanners : LOCAL_BANNERS;
            } catch (error) {
                console.log(error);
                this.banners = LOCAL_BANNERS;
            } finally {
                this.isLoading = false;
            }
        },
        setupDesktopBannerWheel() {
            const banner = this.$refs.homeBanner;
            if (!banner) return;

            this._onHomeBannerWheel = (event) => {
                const scrollContainer = banner.closest('.home-lobby')?.querySelector('.index_rightbar')
                    || banner.closest('.index-scroll-main');
                if (!scrollContainer) return;

                scrollContainer.scrollTop += event.deltaY;
                event.preventDefault();
            };

            banner.addEventListener('wheel', this._onHomeBannerWheel, { passive: false });
            this._homeBannerWheelEl = banner;
        },
        teardownDesktopBannerWheel() {
            if (this._homeBannerWheelEl && this._onHomeBannerWheel) {
                this._homeBannerWheelEl.removeEventListener('wheel', this._onHomeBannerWheel);
                this._homeBannerWheelEl = null;
                this._onHomeBannerWheel = null;
            }
        },
    },
};
</script>

<style scoped>
.home-banner {
    max-width: 100%;
    overflow: hidden;
    background: #06110b;
}

.home-banner__carousel {
    width: 100%;
    height: auto;
}

.home-banner__loading {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 180px;
    background: #06110b;
}

.home-banner ::v-deep .carousel,
.home-banner ::v-deep .carousel-inner,
.home-banner ::v-deep .carousel-item {
    background: #06110b !important;
    border-radius: 0 !important;
    height: auto !important;
}

.home-banner ::v-deep .carousel-item img,
.home-banner ::v-deep img {
    width: 100%;
    height: auto !important;
    display: block;
    border-radius: 0 !important;
    transform-origin: center center;
}

/* Soft Ken Burns on the active slide — premium, keeps eyes on the hero */
.home-banner ::v-deep .carousel-item.active img {
    animation: banner-kenburns 8s ease-in-out infinite alternate;
}

@keyframes banner-kenburns {
    from {
        transform: scale(1);
    }

    to {
        transform: scale(1.045);
    }
}

@media (hover: hover) and (pointer: fine) {
    .home-banner {
        touch-action: pan-y;
    }
}

@media (prefers-reduced-motion: reduce) {
    .home-banner ::v-deep .carousel-item.active img {
        animation: none !important;
    }
}
</style>
